import React from 'react';
import LanguageDropdown from './LanguageDropdown';

const Header = ({ lang, setLang, t }) => {
  return (
    <header className="bg-white/95 backdrop-blur-sm shadow-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <div className="flex items-center">
            <h1 className="text-2xl font-heading font-bold text-primary">{t.logo}</h1>
          </div>

          <nav className="hidden md:flex space-x-8">
            {t.nav.map((item, index) => (
              <a
                key={index}
                href={`#section-${index + 1}`}
                className="text-slate-700 hover:text-primary transition-colors duration-200 font-medium"
              >
                {item}
              </a>
            ))}
          </nav>

          <div className="flex items-center space-x-3 sm:space-x-4">
            <LanguageDropdown lang={lang} setLang={setLang} />

            <a
              href="/s"
              className="bg-primary text-white px-4 sm:px-6 py-2 rounded-lg hover:bg-teal-700 transition-colors duration-200 font-medium inline-block text-sm sm:text-base"
            >
              {t.cta}
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
